import { render, staticRenderFns } from "./newRepair.vue?vue&type=template&id=22116f4d&scoped=true"
import script from "./newRepair.vue?vue&type=script&lang=js"
export * from "./newRepair.vue?vue&type=script&lang=js"
import style0 from "./newRepair.vue?vue&type=style&index=0&id=22116f4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22116f4d",
  null
  
)

export default component.exports